import Vue from 'vue';
import Vuex from 'vuex';
import { authApi } from './api';
import { clearAllStudioRecoveries } from './js/uiConfigRecovery.mjs';

Vue.use(Vuex);

let refreshMeInflight = null;

export default new Vuex.Store({
	state: {
		currentUser: null,
		menus: []
	},
	getters: {
		isLogin: (s) => !!s.currentUser,
		isPlatformAdmin: (s) => !!s.currentUser && s.currentUser.isPlatformAdmin,
		managedOrgIds: (s) => (s.currentUser ? s.currentUser.managedOrgIds : []),
		// 应用入口（门户卡片）与管理菜单（左侧）由后端按角色下发
		appMenus: (s) => (s.menus || []).filter(m => m.type === 'app'),
		adminMenus: (s) => (s.menus || []).filter(m => m.type === 'admin')
	},
	mutations: {
		SET_USER(state, user) { state.currentUser = user; },
		SET_MENUS(state, menus) { state.menus = menus || []; },
		CLEAR(state) { state.currentUser = null; state.menus = []; }
	},
	actions: {
		async login({ commit }, { mobile, password, captchaId, captchaCode, rememberMe }) {
			const user = await authApi.login(mobile, password, captchaId, captchaCode, rememberMe);
			commit('SET_USER', user);
			try {
				commit('SET_MENUS', await authApi.menus());
			} catch (e) {
				if (e && e.status === 401) throw e;
				commit('SET_MENUS', []);
			}
			return user;
		},
		async refreshMe({ commit }) {
			if (refreshMeInflight) return refreshMeInflight;
			refreshMeInflight = (async () => {
				const user = await authApi.me();
				commit('SET_USER', user);
				try {
					commit('SET_MENUS', await authApi.menus());
				} catch (e) {
					if (e && e.status === 401) throw e;
					commit('SET_MENUS', []);
				}
				return user;
			})();
			try {
				return await refreshMeInflight;
			} finally {
				refreshMeInflight = null;
			}
		},
		async logout({ commit }) {
            clearAllStudioRecoveries(typeof localStorage === 'undefined' ? null : localStorage);
			// 即使后端登出接口失败，也必须清空本地会话，避免用户卡在已登录态
			try { await authApi.logout(); } catch (e) { /* 忽略：本地照常清空 */ }
			commit('CLEAR');
		}
	}
});
